// extracted by mini-css-extract-plugin
export var colorSquare = "_tg-0";
export var danger = "_tg-5";
export var lightPink = "_tg-8";
export var neutralBlue = "_tg-7";
export var neutralYellow = "_tg-6";
export var normal = "_tg-1";
export var primary = "_tg-2";
export var primaryLight = "_tg-3";
export var solidBlack = "_tg-g";
export var solidGreen = "_tg-b";
export var solidLightBlue = "_tg-d";
export var solidNavy = "_tg-c";
export var solidOrange = "_tg-f";
export var solidPink = "_tg-e";
export var solidRed = "_tg-9";
export var solidYellow = "_tg-a";
export var success = "_tg-4";